import ThreadsListContainer from '../ThreadsListContainer/ThreadsListContainer';

const FavoritesThreads = () => {

  return (
    <ThreadsListContainer config={{ favoriteOnly: true }} />
  );
}

export default FavoritesThreads;
